import { render, staticRenderFns } from "./CardSingle.vue?vue&type=template&id=d00a85f2&scoped=true"
import script from "./CardSingle.vue?vue&type=script&lang=js"
export * from "./CardSingle.vue?vue&type=script&lang=js"
import style0 from "./CardSingle.vue?vue&type=style&index=0&id=d00a85f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00a85f2",
  null
  
)

export default component.exports